import React, { Component } from 'react'
import { observer } from 'mobx-react'
import Store from '@common/ContactUs/ContactList/store'
import LeaveMessageModal from '@common/ContactUs/LeaveMessage'
import { RouterView } from '@merchant-backend/common-components'
import { dGet } from '@core/utils'
import { EDIT_IMG, PRIVILEGE_STORE_ID } from '@constant'
import { Auth } from '@common/Auth'

const SideBar = RouterView.SideBar

@Auth({ role: [PRIVILEGE_STORE_ID] })
@observer
export default class extends Component {
  constructor(props) {
    super(props)

    this.store = new Store()
  }

  componentDidMount() {
    this.store.getContactList()
  }

  render() {
    const { contactData, leaveMsgStore } = this.store
    const { nickname, tel } = dGet(contactData, 'operator', {})

    return (
      <SideBar title="帮助提示">
        {this.props.children}

        <div
          style={{
            marginTop: 10,
            borderTop: '1px solid #E2E2E2',
            paddingTop: 10
          }}
        >
          专属客户成功经理: {nickname}
        </div>
        <div style={{ marginTop: 10 }}>电话: {tel}</div>

        <div onClick={leaveMsgStore.openMsgBoxModal} style={{ marginTop: 10 }}>
          <img src={EDIT_IMG} />
          <span style={{ color: '#448AFC', marginLeft: 3 }}>给我留言</span>
        </div>

        <LeaveMessageModal store={this.store.leaveMsgStore} />
      </SideBar>
    )
  }
}
